import { z } from "zod";

// The console's Content Security Policy forbids eval (public/_headers). Zod would try `new Function` once to speed up
// parsing and then fall back, but the browser reports the refused attempt as an error; jitless skips the attempt.
// Imported first in main.tsx, before any schema is defined.
z.config({ jitless: true });
